import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { Layout } from './pages/Layout'

import Login from './pages/public/Login'
import ConfirmacaoEmail from './pages/public/ConfirmacaoEmail'
import Recuperarsenha from './pages/public/Recuperarsenha'
import Orcamento from './pages/public/Orcamento'

import Newproject from './pages/private/Newproject'
import Projects from './pages/private/Projects'
import Receipts from './pages/private/Receipts'
import OrcamentoPrivate from './pages/private/Orcamento'
import Users from './pages/private/Users'
import GerarProcuracao from './pages/private/GerarProcuracao'
import Settings from './pages/private/Settings'
import Cadastro from './pages/public/Cadastro'

function PublicPage({ component: Component }) {
  const { isAuthenticated, booting } = useAuth()
  if (booting) return null
  return isAuthenticated ? <Navigate to="/meus-projetos" replace /> : <Component />
}

function RequireAuth({ children }) {
  const { isAuthenticated, booting } = useAuth()
  if (booting) return null
  return isAuthenticated ? children : <Navigate to="/login" replace />
}

export function RoutesApp() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<PublicPage component={Login} />} />
      <Route path="/cadastro" element={<PublicPage component={Cadastro} />} />
      <Route path="/validar-conta" element={<ConfirmacaoEmail />} />
      <Route path="/redefinir-senha" element={<Recuperarsenha />} />
      <Route path="/solicitar-orcamento" element={<Orcamento />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/meus-projetos" element={<Projects />} />
        <Route path="/solicitar-projeto" element={<Newproject />} />
        <Route path="/orcamento" element={<OrcamentoPrivate />} />
        <Route path="/comprovantes" element={<Receipts />} />
        <Route path="/usuarios" element={<Users />} />
        <Route path="/gerar-procuracao" element={<GerarProcuracao />} />
        <Route path="/configuracoes" element={<Settings />} />
      </Route>
    </Routes>
  )
}
